module.exports = __webpack_public_path__ + "img/loading_house.7ea302b0.png";